import axios from "axios";
import { auth } from "firebase/app";

export const iresAxiosInstance = axios.create();

iresAxiosInstance.interceptors.request.use(async (config) => {
  if (config) {
    const idToken = await auth().currentUser?.getIdToken();

    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${idToken}`;
  }
  return config;
});
